import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  marginBottom: (p) => p.spacing(1),
};
